(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/pay-button.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/pay-button.js');
"use strict";


const PayButton = _ref => {
  let sum = _ref.sum,
    onClick = _ref.onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    className = _ref.className;
  const Button = svs.ui.Button;
  const label = svs.core.config.data.svsconfig.isSelfService ? "L\xE4gg i varukorg (".concat(svs.utils.format.Currency(sum), " kr)") : "Betala ".concat(svs.utils.format.Currency(sum), " kr");
  const _svs$tur$ReactPayfoot = svs.tur.ReactPayfooter.utils,
    animateNumbers = _svs$tur$ReactPayfoot.animateNumbers,
    animateButtonPlop = _svs$tur$ReactPayfoot.animateButtonPlop;
  const currentSum = React.useRef(0);
  const payButtonRef = React.useRef();
  React.useEffect(() => {
    if (payButtonRef.current) {
      animateButtonPlop({
        element: payButtonRef.current
      });
      animateNumbers({
        element: payButtonRef.current,
        from: currentSum.current,
        to: sum
      });
      currentSum.current = sum;
    }
  }, [sum]);
  if (isNaN(Number(sum))) return null;
  return React.createElement(Button, {
    className: "payfooter-button ".concat(className),
    disabled: disabled,
    elemRef: payButtonRef,
    focus: true,
    onClick: onClick
  }, label);
};
svs.tur.ReactPayfooter.PayButton = PayButton;

 })(window);